<!-- Button -->
<button mat-icon-button (click)="openPanel()" #shortcutsOrigin>
    <mat-icon [svgIcon]="'heroicons_outline:qrcode'"></mat-icon>
</button>

<!-- Shortcuts panel -->
<ng-template #shortcutsPanel>
    <div
        class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->

        <div class="relative flex flex-col flex-auto sm:max-h-120 -mb-px overflow-y-auto bg-card">

            <!-- View mode -->
            <ng-container *ngIf="mode === 'view' || mode === 'modify'">

                <!-- Shortcuts -->
                <div class="grid grid-cols-2 grid-flow-row">
                    <!-- Shortcut -->
                    <ng-container *ngFor="let shortcut of shortcuts; trackBy: trackByFn">
                        <div
                            class="relative group flex flex-col overflow-hidden bg-card border-r border-b even:border-r-0 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5">
                            <ng-container *ngIf="mode === 'modify'">
                                <div class="absolute inset-0 z-99 cursor-pointer" (click)="editShortcut(shortcut)">
                                </div>
                            </ng-container>
                            <!-- Normal links -->
                            <a class="flex flex-col items-center justify-center w-full h-full py-6 no-underline"
                                *ngIf="!shortcut.useRouter" [ngClass]="{'pointer-events-none': mode === 'modify'}"
                                [href]="shortcut.link">
                                <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                            </a>
                            <!-- Router links -->
                            <a class="flex flex-col items-center justify-center w-full h-full py-6 no-underline"
                                *ngIf="shortcut.useRouter" [ngClass]="{'pointer-events-none': mode === 'modify'}"
                                [routerLink]="shortcut.link">
                                <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                            </a>
                            <!-- Link content template -->
                            <ng-template #linkContent>
                                <div
                                    class="relative flex flex-shrink-0 items-center justify-center w-12 h-12 mb-3 rounded-full bg-gray-100 dark:bg-gray-700">
                                    <mat-icon class="absolute opacity-0 group-hover:opacity-100 z-20 icon-size-5"
                                        *ngIf="mode === 'modify'" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                    <mat-icon class="z-10" [ngClass]="{'group-hover:opacity-0': mode === 'modify'}"
                                        [svgIcon]="shortcut.icon"></mat-icon>
                                </div>
                                <div class="font-medium text-center">{{shortcut.label}}</div>
                                <div class="text-md text-center text-secondary">{{shortcut.description}}</div>
                            </ng-template>
                        </div>
                    </ng-container>
                </div>

                <!-- No shortcuts -->
                <ng-container *ngIf="!shortcuts || !shortcuts.length">
                    <div class="flex flex-col flex-auto items-center justify-center sm:justify-start  px-8">
                        <!-- <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                            <mat-icon
                                class="text-primary-500-700"
                                [svgIcon]="'heroicons_outline:bookmark'"></mat-icon>
                        </div> -->

                        <ngx-qrcode elementType="url" [value]="qrcode" errorCorrectionLevel="L" cssClass="aclass">
                        </ngx-qrcode>
                        <div *ngIf="qrcode">
                            <div class="mt-5 text-2xl font-semibold tracking-tight">Please scan the QR Code</div>
                            <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">Patient ID card/old
                                bills/Reports.</div>
                        </div>
                        <div *ngIf="!qrcode">
                            <div class="mt-5 text-2xl font-semibold tracking-tight">Please connect to scanner</div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Add/Edit mode -->
            <hr style="margin: 8px 0px 0px 0px;">
            <div class="pt-2 text-center">
                <ng-container class = "text-md text-center text-secondary">
                    Don't have a QR code scanner ..?
                    Click here to Link Mobile app
                    <br> 
                    <button class="sm:inline-flex ml-3 mt-2" mat-flat-button [color]="'primary'"
                        (click)="getQRCode();">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:qrcode'"></mat-icon>
                        <span class="ml-2">Get QR Code</span>
                    </button>

                </ng-container>
            </div>
            <hr style="margin: 8px 0px 0px 0px;">
            <div class="pb-2">
                <div *ngFor="let a of activationRequests" class="mt-4 px-2">
                    <ng-container>
                        {{a.code}} ({{a.type}})
                        <button class="sm:inline-flex ml-3 " style= "float: right;"mat-flat-button
                            (click)="activateUser(a);" *ngIf="a.actv_in == 0">
                            <span class="ml-2">Activate</span>
                        </button>
                        <button class="sm:inline-flex ml-3 " style= "float: right;" mat-flat-button
                            (click)="removeUser(a);" *ngIf="a.actv_in == 1">
                            <span class="ml-2">Remove</span>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>